<div class="step-container">
  <div class="d-flex flex-column justify-content-between h-100">
    <div class="mb-5" *ngIf="!loading">
      <div class="d-flex d-lg-none justify-content-center">
        <img src="assets/images/login-registration/registration-logo.svg" class="logo mb-3" />
      </div>
      <h5 class="text-primary text-center text-lg-left">Retriving information from ticketing</h5>
    </div>
    <ng-container *ngIf="loading">
      <div class="w-100">
        <fgbcl-loading></fgbcl-loading>
      </div>
    </ng-container>
    <div class="button-container position-absolute">
      <fgb-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgb-registration-navigation>
    </div>
  </div>
</div>
